import { Anchor, Image, Overlay, Stack, Text } from '@mantine/core'
import { useHover } from '@mantine/hooks'
import { IconSearch } from '@tabler/icons-react'
import { FormattedMessage } from 'react-intl'
import { Link, To } from 'react-router'
import ImagePlaceholder from '@/assets/image-placeholder.png'

const THUMBNAIL_WIDTH = 80
const THUMBNAIL_HEIGHT = 60

type CameraThumbnailProps = {
  imageUrl?: string
  to: To
  replace?: boolean
}

export const CameraThumbnail = ({
  imageUrl,
  to,
  replace
}: CameraThumbnailProps) => {
  const { hovered, ref } = useHover()

  return (
    <Anchor ref={ref} component={Link} to={to} replace={replace} pos="relative">
      <Image
        w={THUMBNAIL_WIDTH}
        h={THUMBNAIL_HEIGHT}
        fit="cover"
        src={imageUrl || ImagePlaceholder}
        fallbackSrc={ImagePlaceholder}
        radius="sm"
        styles={(theme) => ({
          root: {
            outline: `1px solid ${theme.colors.dark[3]}`
          }
        })}
      />

      {hovered && (
        <Overlay backgroundOpacity={0.8} center>
          <Stack justify="center" align="center" gap={4}>
            <IconSearch size={14} color="white" />

            <Text size="xs" fw={600} c="white">
              <FormattedMessage id="cameras.list.buttons.view" />
            </Text>
          </Stack>
        </Overlay>
      )}
    </Anchor>
  )
}
